import { memo, useCallback, useEffect, useState } from 'react';
import { ActivityIndicator, AppState, StyleSheet, Text } from 'react-native';
import { MainStackProps } from '../../types/screens';
import moment from 'moment';
import { AccountProvider } from '../../data';
import AppColors from '../../common/colors';
import localization from '../../common/localization';
import useGlobalStyles from '../../common/style_context';
import KeyWrapper from '../../components/key_wrapper';

type Props = MainStackProps<'BlankTv'>;

const blankStyles = ['fs=40,fw=400,c=white,mt=12'];

const BlankTv = memo<Props>(({ navigation, route: { params } }) => {
  const [lastCheck, setLastCheck] = useState(0);
  const [wait, setWait] = useState(false);

  const [textStyle] = useGlobalStyles(blankStyles);

  useEffect(() => {
    const t = setTimeout(async () => {
      try {
        if (AppState.currentState !== 'active') throw 'App in background';
        await AccountProvider.checkNetwork();

        if (params === undefined) navigation.replace('Tv');
        else {
          navigation.replace('PlayerTv', {
            id: params.id,
            info: params.info,
            startPosition: params.position,
          });
        }
      } catch (err: any) {
        setWait(!(err instanceof String));
        setLastCheck(moment().unix());
      }
    }, 3000);
    return () => clearTimeout(t);
  }, [lastCheck]);

  const cancel = useCallback(() => {
    if (navigation.canGoBack()) {
      if (params !== undefined) {
        navigation.pop();
        return;
      }
      navigation.popToTop();
    }
    navigation.replace('MainTv');
  }, []);

  return (
    <KeyWrapper cancel={cancel} style={styles.container}>
      {wait && (
        <>
          <ActivityIndicator color={AppColors.mainBlue} size={'large'} />
          <Text style={textStyle}>
            {localization.general.waitingForNetwork}
          </Text>
        </>
      )}
    </KeyWrapper>
  );
});
BlankTv.displayName = 'BlankTv';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default BlankTv;
